export default __webpack_public_path__ + "media/gs_upgrade_email/copy_icon-12234f68.png";